import { TEntityResponse, TEntityListResponse, TLoginLogResBody, TLoginLogSummaryResBody } from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TLoginLogsClient = {
  get(id: string): Promise<TEntityResponse<'login-log', TLoginLogResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'login-log', TLoginLogSummaryResBody> | undefined>;
  get_user_logs_list(
    userId: string,
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'login-log', TLoginLogSummaryResBody> | undefined>;
};

function LoginLogsClient(apiClient: TAPIClient): TLoginLogsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'login-log', TLoginLogResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'login-log', TLoginLogResBody>>(`/login-logs/${id}`);

      if (data && data.type !== 'login-log') {
        throw new Error('Invalid entity type received, expected: login-log, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'login-log', TLoginLogSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'login-log', TLoginLogSummaryResBody>>(
        `/login-logs?sort[created_at]=desc&limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'login-log') {
        throw new Error('Invalid entity type received, expected: login-log, received: ' + data.type);
      }

      return data;
    },

    async get_user_logs_list(
      userId: string,
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'login-log', TLoginLogSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'login-log', TLoginLogSummaryResBody>>(
        `/login-logs?sort[created_at]=desc&filter[user_id]=${userId}&limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'login-log') {
        throw new Error('Invalid entity type received, expected: login-log, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TLoginLogsClient, LoginLogsClient };
